// Scheduled Messages API client (WP-04).
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import { stripUndefined } from './callable';

export interface ScheduledPayload {
  body?: string;
  templateName?: string;
  templateLanguage?: string;
  templateVariables?: string[];
  mediaId?: string;
  mediaUrl?: string;
  caption?: string;
  asDocument?: boolean;
  mediaType?: 'image' | 'video' | 'audio' | 'document';
}

export interface ScheduledMessageDoc {
  id: string;
  tenantId: string;
  conversationId: string;
  subscriberId?: string;
  phoneE164: string;
  payload: ScheduledPayload;
  sendAt: number;
  timezone: string;
  status: 'pending' | 'sent' | 'failed' | 'cancelled';
  scheduledBy: string;
  createdAt: number;
  executedAt?: number;
  error?: string;
}

function call<TReq, TRes>(name: string) {
  const fn = httpsCallable<TReq, TRes>(functions, name);
  return async (data: TReq): Promise<TRes> => (await fn(stripUndefined(data))).data;
}

export const scheduleMessage = call<
  {
    conversationId: string;
    payload: ScheduledPayload;
    sendAt: number | string;
    timezone?: string;
  },
  { ok: boolean; id: string; sendAtUtcMs: number }
>('messageSchedule');

export const cancelScheduledMessage = call<{ id: string }, { ok: boolean }>('messageScheduleCancel');

export const listScheduledMessages = call<
  { conversationId?: string; status?: 'pending' | 'sent' | 'failed' | 'cancelled'; limit?: number },
  { ok: boolean; items: ScheduledMessageDoc[] }
>('messageScheduleList');
